<template>
  <div class="spinner-container">
    <div
      class="spinner-grow text-success"
      style="width: 2rem; height: 2rem"
      role="status"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
    <div
      class="spinner-grow text-success"
      style="width: 4rem; height: 4rem"
      role="status"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
    <div
      class="spinner-grow text-success"
      style="width: 2rem; height: 2rem"
      role="status"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
</style>